import { styled } from '@linaria/react';

import ButtonRainbow from '@/components/ButtonRainbow';

export default function ButtonDemo() {
  return (
    <Wrapper>
      <ButtonRainbow id="gradient-fx-demo" style={{ width: 175 }}>
        Swirly!
      </ButtonRainbow>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 48px;
  margin-bottom: 32px;
  display: grid;
  place-content: center;
`;
